// export const BASE_URL = 'http://65.1.32.48/';
export const BASE_URL = 'https://api.currycook.com/';
// export const BASE_URL = 'http://184.154.83.98/';